var _g, _path, _path2, _g2, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 400",
    "data-background-color": "#f9f9f9",
    preserveAspectRatio: "xMidYMid meet",
    height: 400,
    width: 640,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,122.24000000000001,126.70239791226979)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 146.59520417546042",
    height: 146.59520417546042,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 397.4975999999999 147.3281801963377",
    height: 146.59520417546042,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 397.4975999999999,
    height: 4.5124675736028275,
    x: 0,
    y: 80.96509121369303,
    fill: "#030303",
    opacity: 1,
    strokeWidth: 0,
    stroke: "transparent",
    fillOpacity: 1,
    className: "rect-o-0",
    "data-fill-palette-color": "secondary",
    rx: "1%",
    id: "o-0",
    "data-palette-color": "#030303"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.9887999999999693,97.29030112657028)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 50.03787906976744",
    height: 50.03787906976744,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 50.03787906976744",
    height: 50.03787906976744,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 50.03787906976744",
    height: 50.03787906976744,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    viewBox: "3 -33.5 268.739990234375 34",
    height: 50.03787906976744,
    "data-palette-color": "#030303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 0L3 0 3-0.8 7.05-2.8 7.05-30.2 3-32.2 3-33 27.6-33 27.6-24.4 26.8-24.4 23.65-30.25 12.3-30.25 12.3-18.35 20.1-18.35 22.65-22.55 23.45-22.55 23.45-11.6 22.65-11.6 20.1-15.7 12.3-15.7 12.3-2.8 16.9-0.8 16.9 0ZM43.2 0L32.4 0 32.4-0.8 35.55-2.45 48.4-33.25 51.15-33.25 63.85-2.6 67.2-0.8 67.2 0 54 0 54-0.8 58.4-2.55 54.7-11.55 42.65-11.55 39-2.5 43.2-0.8 43.2 0ZM48.7-26.35L43.8-14.3 53.6-14.3 48.7-26.35ZM82.8 0L71.5 0 71.5-0.8 75.5-2.8 76.55-30.2 72.25-32.2 72.25-33 82.2-33 93.4-7.15 104.55-33 114.1-33 114.1-32.2 109.85-30.35 110.7-2.8 114.3-0.8 114.3 0 101.95 0 101.95-0.8 105.7-2.75 105.2-27.2 93.4 0.25 91 0.25 79.3-26.9 78.65-2.75 82.8-0.8 82.8 0ZM137.09 0.5L137.09 0.5Q131.94 0.5 128.19-1.6 124.44-3.7 122.39-7.35 120.34-11 120.34-15.65L120.34-15.65Q120.34-19.25 121.74-22.45 123.14-25.65 125.57-28.15 127.99-30.65 131.14-32.08 134.29-33.5 137.84-33.5L137.84-33.5Q140.39-33.5 142.14-33.18 143.89-32.85 145.27-32.33 146.64-31.8 148.04-31.1L148.04-31.1 148.34-22.2 147.44-22.2 143.99-28.7Q142.29-29.9 140.92-30.45 139.54-31 137.84-31L137.84-31Q134.39-31 131.64-29.2 128.89-27.4 127.32-24.23 125.74-21.05 125.74-16.9L125.74-16.9Q125.74-12.25 127.27-8.93 128.79-5.6 131.39-3.85 133.99-2.1 137.14-2.1L137.14-2.1Q139.74-2.1 141.52-2.8 143.29-3.5 144.69-4.45L144.69-4.45 148.04-10.05 148.89-10.05 148.29-2Q146.09-0.9 143.59-0.2 141.09 0.5 137.09 0.5ZM168.99 0.25L166.99 0.25 157.69-30.35 153.89-32.2 153.89-33 167.34-33 167.34-32.2 163.09-30.35 169.19-9.25 169.49-9.25 178.14-33.25 180.24-33.25 189.04-9.25 189.34-9.25 195.39-30.3 191.14-32.2 191.14-33 202.24-33 202.24-32.2 198.89-30.4 189.49 0.25 187.44 0.25 178.44-23.7 178.09-23.7 168.99 0.25ZM232.44 0L205.94 0 205.94-0.8 209.99-2.8 209.99-30.2 205.94-32.2 205.94-33 231.04-33 231.04-24.4 230.24-24.4 226.99-30.25 215.24-30.25 215.24-18.4 223.54-18.4 226.09-22.6 226.89-22.6 226.89-11.55 226.09-11.55 223.54-15.65 215.24-15.65 215.24-2.75 228.34-2.75 231.64-9.35 232.44-9.35 232.44 0ZM253.74 0L238.89 0 238.89-0.8 242.94-2.8 242.94-30.2 238.89-32.2 238.89-33 254.09-33Q259.69-33 263.64-31.05 267.59-29.1 269.66-25.7 271.74-22.3 271.74-18L271.74-18Q271.74-14.1 270.39-10.8 269.04-7.5 266.61-5.1 264.19-2.7 260.91-1.35 257.64 0 253.74 0L253.74 0ZM252.74-30.25L252.74-30.25 248.19-30.25 248.19-2.75 253.49-2.75Q257.49-2.75 260.34-4.42 263.19-6.1 264.74-9.18 266.29-12.25 266.29-16.45L266.29-16.45Q266.29-20.6 264.71-23.73 263.14-26.85 260.11-28.55 257.09-30.25 252.74-30.25Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#030303",
    className: "undefined-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,151.3245743181445,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 94.84845136371094 69.1523488744186",
    height: 69.1523488744186,
    width: 94.84845136371094,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 8,
    y: 0,
    viewBox: "33.73099899291992 35.638999938964844 32.53599166870117 28.534996032714844",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    height: 69.1523488744186,
    width: 78.84845136371094,
    className: "icon-icon-0",
    "data-fill-palette-color": "accent",
    id: "icon-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.593 55.781c-2.514-1.612-4.101-3.671-4.844-6.103-0.801-2.625-2.026-4.741-4.871-4.741-3.213 0-4.976 2.604-4.976 5.815v13.42h9.95v-6.807c0.714 0.691 1.525 1.349 2.471 1.955 0.352 0.225 0.744 0.333 1.133 0.333 0.692 0 1.37-0.342 1.771-0.968C49.854 57.709 49.57 56.409 48.593 55.781zM39.734 43.874c2.274 0 4.117-1.843 4.117-4.117s-1.843-4.118-4.117-4.118c-1.477 0-2.761 0.782-3.483 1.952-0.202 0.327-1.04 1.811-2.52 1.306C34.356 41.771 36.586 43.874 39.734 43.874zM60.437 43.874c2.273 0 4.116-1.843 4.116-4.117s-1.843-4.118-4.116-4.118-4.117 1.844-4.117 4.118S58.163 43.874 60.437 43.874zM61.294 44.938c-2.846 0-4.07 2.116-4.872 4.741-0.743 2.432-2.331 4.49-4.844 6.103-0.978 0.628-1.262 1.928-0.636 2.905 0.402 0.626 1.079 0.968 1.772 0.968 0.389 0 0.781-0.108 1.133-0.333 0.944-0.606 1.756-1.264 2.471-1.955v6.807h9.949v-13.42C66.268 47.541 64.506 44.938 61.294 44.938zM54.216 47.746c0-1.228-0.995-2.222-2.222-2.222-0.813 0-1.52 0.437-1.907 1.086-0.388-0.649-1.096-1.086-1.908-1.086-1.227 0-2.221 0.994-2.221 2.222 0 2.517 4.128 4.272 4.128 4.272S54.216 50.263 54.216 47.746z",
    fill: "#030303",
    "data-fill-palette-color": "accent"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 74.79145431814453,
    height: 4.5124675736028275,
    y: 63.63988130081577,
    x: 246.17302568185545,
    fill: "#030303",
    "data-fill-palette-color": "secondary"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 74.79145431814453,
    height: 4.5124675736028275,
    y: 63.63988130081577,
    x: 76.53311999999997,
    fill: "#030303",
    "data-fill-palette-color": "secondary"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 146.59520417546042,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo3.6be59addf8a242123d701ea807869902.svg";
export { ForwardRef as ReactComponent };